<template>
  <div class="grid">
	<template v-if="loader==true">
		<div class="col-12 mb-2 lg:col-12">
			<ProgressBar mode="indeterminate" style="height: .5em" />
		</div>
	</template>
	<div class="field col-12">
		<template v-if="temperaturas_sigueme">
			<!-- <template v-if="temperaturas_sigueme.success==true"> -->
				<!-- {{temperaturas_sigueme.viaje}} -->
				<div class="grid p-fluid text-center">
					<!-- <template v-if="temperaturas_sigueme.viaje.temperaturas.length==0"> -->
					<template v-if="temperaturas_sigueme.length==0">
						<div class="field col-12 shadow-1 rounded-normal p-3">
							<i class="pi pi-exclamation-circle m-3" style="font-size: 5rem"></i><br>
							<span class="mb-1 mx-3"><strong>SIN TEMPERATURAS</strong><br>
							No sé encuentran temperaturas relacionadas a este viaje
							</span>
						</div>
					</template>
					<template v-else>
						<div class="col-2">
							<div class="card height-100">
								<div class="card-header">
									<h5>Controles</h5>
								</div>

								<Button label="Vista Generador" icon="pi pi-eye" class="p-button-text" @click="openModalVistaGenardor"/>
								<!-- <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_info = false"/> -->
				    			

								<h6>Lo puede ver el generador</h6>
								<InputSwitch v-model="vista_temperatura" :true-value="1" :false-value="0" />
								<template v-if="vista_temperatura==0">
									<p>NO</p>
								</template>
								<template v-else>
									<p>SI</p>
								</template>
								<!-- {{vista_temperatura}} -->

								<Button label="Guardar Cambios" :loading="loader" icon="pi pi-save" class="p-button-text" @click="guardar_cambio_temperatura"/>
							</div>
						</div>
						<div class="col-8">
							<Chart ref="chart" type="line" :data="chartData" :options="chartOptions" responsive="true" @click="handleChartClick" />
						</div>
						<div class="col-2">
							<div class="card height-100">
								<div class="card-header">
									<h5>Indicadores</h5>
								</div>

								<ul class="widget-activity">
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Inicial</div>
											<div class="activity-subtext mb-1">{{temperaturas_sigueme[0].fecha}}</div>
											<div class="activity-subtext mb-2">{{temperaturas_sigueme[0].temperatura}} °C</div>
											<ProgressBar :value="parseFloat(temperaturas_sigueme[temperaturas_sigueme.length - 1].temperatura)" :showValue="false"></ProgressBar>
											<!-- <div class="activity-title mb-1">Temperatura Inicial</div>
											<div class="activity-subtext mb-1">{{temperaturas_sigueme.viaje.temperaturas[0].fecha}}</div>
											<div class="activity-subtext mb-2">{{temperaturas_sigueme.viaje.temperaturas[0].temperatura}} °C</div>
											<ProgressBar :value="parseFloat(temperaturas_sigueme.viaje.temperaturas[temperaturas_sigueme.viaje.temperaturas.length - 1].temperatura)" :showValue="false"></ProgressBar> -->
										</div>
									</li>
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Final</div>
											<div class="activity-subtext mb-1">{{temperaturas_sigueme[temperaturas_sigueme.length - 1].fecha}}</div>
											<div class="activity-subtext mb-2">{{temperaturas_sigueme[temperaturas_sigueme.length - 1].temperatura}} °C</div>
											<ProgressBar :value="parseFloat(temperaturas_sigueme[temperaturas_sigueme.length - 1].temperatura)" :showValue="false"></ProgressBar>
											<!-- <div class="activity-title mb-1">Temperatura Final</div>
											<div class="activity-subtext mb-1">{{temperaturas_sigueme.viaje.temperaturas[temperaturas_sigueme.viaje.temperaturas.length - 1].fecha}}</div>
											<div class="activity-subtext mb-2">{{temperaturas_sigueme.viaje.temperaturas[temperaturas_sigueme.viaje.temperaturas.length - 1].temperatura}} °C</div>
											<ProgressBar :value="parseFloat(temperaturas_sigueme.viaje.temperaturas[temperaturas_sigueme.viaje.temperaturas.length - 1].temperatura)" :showValue="false"></ProgressBar> -->
										</div>
									</li>
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Promedio</div>
											<div class="activity-subtext mb-2">{{promedio_temperatura}} °C</div>
											<ProgressBar :value="parseFloat(promedio_temperatura)" :showValue="false"></ProgressBar>
										</div>
									</li>
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Máxima</div>
											<div class="activity-subtext mb-2">{{temperatua_max}} °C</div>
											<ProgressBar :value="parseFloat(temperatua_max)" :showValue="false"></ProgressBar>
										</div>
									</li>
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Minima</div>
											<div class="activity-subtext mb-2">{{temperatua_min}} °C</div>
											<template v-if="temperatua_min>0">
												<ProgressBar :value="parseFloat(temperatua_min)" :showValue="false"></ProgressBar>
											</template>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</template>
				</div>
			<!-- </template> -->
		</template>
	</div>
	<Dialog v-model:visible="modalVisible" header="Detalle de Temperatura" :style="{width: '400px'}" :modal="true">
		<div class="grid p-fluid text-center mt-2">
			<div class="col-12">
			<p><strong>Fecha:</strong> {{ selectedData.fecha }}</p>
			<!-- temperatura_editable -->
			<template v-if="temperatura_editable==true">
				<span class="p-float-label">
					<InputText v-model="selectedData.temperatura" id="temperatura" type="number" />
					<label for="temperatura">Temperatura</label>
				</span>
			</template>
			<template v-else>
				<p><strong>Temperatura:</strong> {{ selectedData.temperatura }}°C</p>
			</template>
			</div>
		</div>
		<template #footer>
			<Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modalVisible = false"/>
			<template v-if="temperatura_editable==true">
				<Button label="Editar" :loading="loader" icon="pi pi-check" class="p-button-text" @click="cambio_temperatura"/>
			</template>
		</template>
	</Dialog>
	<Dialog v-model:visible="modal_vista_generador" header="Detalle de Temperatura" :style="{width: '1000px'}" :modal="true">
		<div class="grid p-fluid text-center">
			<div class="col-9">
			<Chart ref="chart" type="line" :data="chartData_fake" :options="chartOptions" responsive="true" />
			</div>
			<div class="col-3">
			<div class="card height-100">
								<div class="card-header">
									<h5>Indicadores</h5>
								</div>

								<ul class="widget-activity">
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Inicial</div>
											<div class="activity-subtext mb-1">{{temperaturas_sigueme[0].fecha}}</div>
											<div class="activity-subtext mb-2">{{temperaturas_sigueme[0].temperaturas_fake}} °C</div>
											<ProgressBar :value="parseFloat(temperaturas_sigueme[temperaturas_sigueme.length - 1].temperaturas_fake)" :showValue="false"></ProgressBar>
										</div>
									</li>
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Final</div>
											<div class="activity-subtext mb-1">{{temperaturas_sigueme[temperaturas_sigueme.length - 1].fecha}}</div>
											<div class="activity-subtext mb-2">{{temperaturas_sigueme[temperaturas_sigueme.length - 1].temperaturas_fake}} °C</div>
											<ProgressBar :value="parseFloat(temperaturas_sigueme[temperaturas_sigueme.length - 1].temperaturas_fake)" :showValue="false"></ProgressBar>
										</div>
									</li>
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Promedio</div>
											<div class="activity-subtext mb-2">{{promedio_temperatura_fake}} °C</div>
											<ProgressBar :value="parseFloat(promedio_temperatura_fake)" :showValue="false"></ProgressBar>
										</div>
									</li>
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Máxima</div>
											<div class="activity-subtext mb-2">{{temperatua_max_fake}} °C</div>
											<ProgressBar :value="parseFloat(temperatua_max_fake)" :showValue="false"></ProgressBar>
										</div>
									</li>
									<li>
										<div class="activity-item flex flex-column">
											<div class="activity-title mb-1">Temperatura Minima</div>
											<div class="activity-subtext mb-2">{{temperatua_min_fake}} °C</div>
											<template v-if="temperatua_min_fake>0">
												<ProgressBar :value="parseFloat(temperatua_min_fake)" :showValue="false"></ProgressBar>
											</template>
										</div>
									</li>
								</ul>
							</div>
			</div>
		</div>
		<template #footer>
			<Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_vista_generador = false"/>
			<template v-if="temperatura_editable==true">
				<Button label="Editar" :loading="loader" icon="pi pi-check" class="p-button-text" @click="cambio_temperatura"/>
			</template>
		</template>
	</Dialog>
  </div>
</template>

<script>
import { APIENDPOINTIMG } from '../../../app.config'
export default {
	data() {
		return {
			message: [],
			info_detalle_mov: [],
			customers: [],
			detalle_reme: [],
			details_remesa: [],
			code_seway: '',
			code_cumplido: '',
			sinimagen: [],
			list_cumplidos: [],
			list_sucursales: [],
			loader: false,
			modalVisible: false,
			modal_vista_generador: false,
			selectedData: { fecha: "", temperatura: "" },
			galleriaResponsiveOptions: [
                {
                    breakpoint: "724px",
                    numVisible: 5,
                },
                {
                    breakpoint: "660px",
                    numVisible: 4,
                },
                {
                    breakpoint: "168px",
                    numVisible: 3,
                },
                {
                    breakpoint: "160px",
                    numVisible: 1,
                },
            ],
			chartData: {},
			chartData_fake: {},
			chartOptions: {
				// maintainAspectRatio: false,
				responsive: true,
				width: 400, // Define el ancho deseado para la gráfica
				height: 200, // Define el alto deseado para la gráfica
				scales: {
					y: {
						beginAtZero: true
					}
				}
			},
			loading: false,
			temperatura_editable: false,
			promedio_temperatura: 0,
			promedio_temperatura_fake: 0,
			temperatua_max: 0,
			temperatua_max_fake: 0,
			temperatua_min: 0,
			temperatua_min_fake: 0,
		}
	},
	props: ['Customer','temperaturas_sigueme','id_viaje','IdCustomer','vista_temperatura'],
	// },
  	mounted(){
		// this.sinimagen[0].identificacion = 'Sin imagen';
		this.sinimagen = APIENDPOINTIMG+'img_profiles/profile.jpg';
		// if (this.temperaturas_sigueme?.viaje?.temperaturas) {
		// 	this.chartData = this.getchartData(this.temperaturas_sigueme.viaje.temperaturas);
		// }
			if (this.temperaturas_sigueme?.length) {
				this.chartData = this.getchartData(this.temperaturas_sigueme);
				this.chartData_fake = this.getchartDataFake(this.temperaturas_sigueme);
			}
		// this.loadGeneradores();
	},
	watch: {
		temperaturas_sigueme: {
			deep: true,
			handler(newValue) {
				if (newValue?.length) {
					this.chartData = this.getchartData(newValue);
					this.chartData_fake = this.getchartDataFake(newValue);
				}
			}
		}
	},

	// watch: {
	// 	temperaturas_sigueme: {
	// 		deep: true,  // Detecta cambios dentro del objeto
	// 		handler(newValue) {
	// // 			if (newValue?.viaje?.temperaturas) {
	// 				this.chartData = this.getchartData(newValue);
	// // 			}
	// 		}
	// 	}
	// },
	methods:{
		guardar_cambio_temperatura() {
			this.info_detalle_mov = [];
			var _that = this;
			this.loader = true;
			console.log(this.chartData);
			var url = 'guardar_cambio_temperatura';
			window.api.call('post', url, {id_customer: this.IdCustomer,id_viaje: this.id_viaje,chart_temperaturas: this.chartData,vista_temperatura: this.vista_temperatura}).then( function(response) {
				if(response.status == 200){
					_that.loader = false;
					_that.$toast.add({ severity: 'success', summary: 'Temperaturas:', detail: 'se edito correctamente!', life: 6000 });
				}
			}).catch(function (err) {
				// _that.loading[0] = false;
				_that.loader = false;
				console.log(err);
				
				// _that.loading[slot.index] = false;
			});
		},
		handleChartClick(event) {
			// Obtener la referencia del gráfico desde this.$refs
			const chartInstance = this.$refs.chart.chart;

			if (!chartInstance) return; // Validar si el gráfico está inicializado

			// Obtener elementos en la posición del clic
			const points = chartInstance.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

			if (!points.length) return; // No hay elementos en el clic

			const index = points[0].index; // Índice del punto seleccionado
			const datasetIndex = points[0].datasetIndex;
			// console.log(points);
			// console.log(index);
	
			this.selectedData = {
				index: index,
				datasetIndex: datasetIndex,
				fecha: this.chartData.labels[index],
				temperatura: this.chartData.datasets[datasetIndex].data[index]
			};
			if (datasetIndex==1) {
				this.temperatura_editable = true;
			}else{
				this.temperatura_editable = false;
			}
			this.modalVisible = true; // Mostrar modal con la información
		},
		getchartData(data) {
			
			var labels = [];
			var temperaturas = [];
			var temperaturas_fake = [];
			this.promedio_temperatura = 0;
			this.temperatua_max = 0;
			this.temperatua_min = 0;
			// let num = 12;
			// Recorre los datos y extrae las etiquetas (fechas) y las temperaturas
			data.forEach(temperatura => {

				// if (labels.length < 10) {
					labels.push(temperatura.fecha);
					temperaturas.push(temperatura.temperatura);
					temperaturas_fake.push(temperatura.temperaturas_fake - 0.5

					);
					// let temp_fake = temperatura.temperatura + (Math.random() * 2 - 1); // Variación de ±1 grado
    				// temperaturas_fake.push(temp_fake);
					// num = num + 5;
					// temperaturas_fake.push(num);
					this.promedio_temperatura = this.promedio_temperatura + parseFloat(temperatura.temperatura);
				// }
			});
			// Define el objeto del conjunto de datos
			var dataset = {
				label: "Temperatura",
				backgroundColor: "rgba(75, 192, 192, 0.2)",
				borderColor: "rgba(75, 192, 192, 1)",
				data: temperaturas
			};

			var dataset_fake = {
				label: "Temperaturas Fake",
				backgroundColor: "rgba(255, 99, 132, 0.2)",
				borderColor: "rgba(255, 99, 132, 1)",
				data: temperaturas_fake,
				fill: false
			};
			// console.log('total suma temperaturas: '+this.promedio_temperatura);
			
			this.promedio_temperatura = this.promedio_temperatura/(data.length);

			// console.log('cantidad para dividir: '+parseInt(data.length));
			// console.log('total dividido cantidad de posiciones temperaturas: '+this.promedio_temperatura);

			this.promedio_temperatura = this.promedio_temperatura.toFixed(1);

			// console.log('total toFixed: '+this.promedio_temperatura);

			let valoresTemperaturas = data.map(item => parseFloat(item.temperatura));
			this.temperatua_max = Math.max(...valoresTemperaturas);
			this.temperatua_min = Math.min(...valoresTemperaturas);

			// console.log(dataset_fake);
			
			// Devuelve el objeto chartData con las etiquetas y el conjunto de datos
			return {
				labels: labels,
				datasets: [dataset, dataset_fake] // Convierte el objeto en un array para que sea válido
			};

        },
		getchartDataFake(data) {
			
			var labels = [];
			var temperaturas = [];
			var temperaturas_fake = [];
			this.promedio_temperatura_fake = 0;
			this.temperatua_max_fake = 0;
			this.temperatua_min_fake = 0;
			// Recorre los datos y extrae las etiquetas (fechas) y las temperaturas
			data.forEach(temperatura => {

					labels.push(temperatura.fecha);
					temperaturas.push(temperatura.temperatura);
					temperaturas_fake.push(temperatura.temperaturas_fake - 0.5

					);
					this.promedio_temperatura_fake = this.promedio_temperatura_fake + parseFloat(temperatura.temperaturas_fake);
				// }
			});

			var dataset_fake = {
				label: "Temperaturas Fake",
				backgroundColor: "rgba(255, 99, 132, 0.2)",
				borderColor: "rgba(255, 99, 132, 1)",
				data: temperaturas_fake,
				fill: false
			};
			// console.log('total suma temperaturas: '+this.promedio_temperatura);
			
			this.promedio_temperatura_fake = this.promedio_temperatura_fake/(data.length);

			// console.log('cantidad para dividir: '+parseInt(data.length));
			// console.log('total dividido cantidad de posiciones temperaturas: '+this.promedio_temperatura);

			this.promedio_temperatura_fake = this.promedio_temperatura_fake.toFixed(1);

			// console.log('total toFixed: '+this.promedio_temperatura);

			let valoresTemperaturas = data.map(item => parseFloat(item.temperaturas_fake));
			this.temperatua_max_fake = Math.max(...valoresTemperaturas);
			this.temperatua_min_fake = Math.min(...valoresTemperaturas);

			// Devuelve el objeto chartData con las etiquetas y el conjunto de datos
			return {
				labels: labels,
				// datasets: [dataset, dataset_fake] // Convierte el objeto en un array para que sea válido
				datasets: [dataset_fake] // Convierte el objeto en un array para que sea válido
			};

        },
		cambio_temperatura(){
			// console.log(this.selectedData.index);
			// console.log(this.chartData);
			this.chartData.datasets[this.selectedData.datasetIndex].data[this.selectedData.index] = this.selectedData.temperatura;
			this.modalVisible = false;
		},
		openModalVistaGenardor(){
			this.modal_vista_generador = true;
			// this.promedio_temperatura_fake = 0;
		}
	}
};
</script>